<template>
  <div>
    <div class="clients" :class="{'darkMode' : state.darkMode}">
      <div class="w3-container">
        <div class="headerGrid" style="padding:12px 4px;">
          <div>
            <header>
              <h5 class="comfortaa">{{selectedClient.name}}</h5>
              <p>{{selectedClient.email}}</p>
            </header>
          </div>
          <div>
            <router-link to="/clients" class="w3-button w3-red w3-small w3-right vmiddle">
              <i class="fas fa-times" style="margin-right:8px;"></i>Close
            </router-link>
            <button @click="updateClient()" v-if="activeTab === 'contact'" class="w3-button w3-green w3-small w3-right vmiddle" style="margin-right:8px;">
              <i class="fas fa-save" style="margin-right:8px;"></i>Update
            </button>
            <button @click="addInvoice = true" v-if="activeTab === 'invoices'" class="w3-button w3-green w3-small w3-right vmiddle" style="margin-right:8px;">
              <i class="fas fa-plus" style="margin-right:8px;"></i>New Invoice
            </button>
          </div>
        </div>

        <div class="w3-row">
          <div class="w3-white w3-round" style="box-shadow: 0 0 0 1px #ccc;">
            <header class="w3-bar w3-light-grey">
              <div class="w3-bar-item" :class="activeTab === 'contact' ? 'dark' : ''" style="border-radius: 3px 0 0 0;" @click="activeTab = 'contact'">Contact</div>
              <div class="w3-bar-item" :class="activeTab === 'invoices' ? 'dark' : ''" @click="activeTab = 'invoices'">Invoices</div>
              <div class="w3-bar-item" :class="activeTab === 'domains' ? 'dark' : ''" @click="activeTab = 'domains'">Domains</div>
              <div class="w3-bar-item" :class="activeTab === 'subscriptions' ? 'dark' : ''" @click="activeTab = 'subscriptions'">Subscriptions</div>
            </header>
            <div class="cardBody">
              <!-- Contact -->
              <template v-if="activeTab === 'contact'">
                <div class="w3-row-padding w3-padding-v">
                  <div class="w3-col w3-third">
                    <input class="w3-input w3-border w3-round" type="text" placeholder="Name" v-model="selectedClient.name">
                  </div>
                  <div class="w3-col w3-third">
                    <input class="w3-input w3-border w3-round" type="text" placeholder="Company" v-model="selectedClient.company">
                  </div>
                  <div class="w3-col w3-third">
                    <select class="w3-select w3-border w3-round" style="padding-left:8px;" v-model="selectedClient.status">
                      <option value="active">Active</option>
                      <option value="draft">Draft</option>
                      <option value="suspended">Suspended</option>
                      <option value="cancelled">Cancelled</option>
                    </select>
                  </div>
                </div>
                <div class="w3-row-padding w3-padding-bottom">
                  <div class="w3-col w3-half">
                    <input class="w3-input w3-border w3-round" type="email" placeholder="Email" v-model="selectedClient.email" disabled>
                  </div>
                  <div class="w3-col w3-half">
                    <input class="w3-input w3-border w3-round" type="text" placeholder="Phone" v-model="selectedClient.phone">
                  </div>
                </div>
                <div class="w3-row-padding w3-padding-bottom">
                  <div class="w3-col w3-half">
                    <input class="w3-input w3-border w3-round" type="text" placeholder="Street Address 1" v-model="selectedClient.address1">
                  </div>
                  <div class="w3-col w3-half">
                    <input class="w3-input w3-border w3-round" type="text" placeholder="Street Address 2" v-model="selectedClient.address2">
                  </div>
                </div>
                <div class="w3-row-padding w3-padding-bottom">
                  <div class="w3-col w3-third">
                    <input class="w3-input w3-border w3-round" type="text" placeholder="City" v-model="selectedClient.city">
                  </div>
                  <div class="w3-col w3-third">
                    <input class="w3-input w3-border w3-round" type="text" placeholder="State" v-model="selectedClient.state">
                  </div>
                  <div class="w3-col w3-third">
                    <input class="w3-input w3-border w3-round" type="number" placeholder="Zip" v-model="selectedClient.zipcode">
                  </div>
                </div>
                <div class="w3-row-padding w3-padding-bottom">
                  <div class="w3-col">
                    <input class="w3-input w3-border w3-round" type="text" placeholder="Change Password" v-model="selectedClient.password">
                  </div>
                </div>
              </template>
              
              <!-- Invoices -->
              <template v-if="activeTab === 'invoices'">
                <template v-if="!addInvoice">
                  <invoicesList :selectedClient="selectedClient"></invoicesList>
                </template>
                <template v-if="addInvoice">
                  <addInvoice :selectedClient="selectedClient"></addInvoice>
                </template>
              </template>

              <!-- Domains -->
              <template v-if="activeTab === 'domains'">
                <domainsList :selectedClient="selectedClient"></domainsList>
              </template>
              
              <!-- Subscriptions -->
              <template v-if="activeTab === 'subscriptions'">
                <subscriptionList></subscriptionList>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dataStore from '../dataStore';
import invoicesList from '@/components/invoicesList'
import domainsList from '@/components/domainsList'
import addInvoice from '@/components/addInvoice'
import subscriptionList from '@/components/subscriptionList'

export default {
  name: "ClientDetails",
  data() {
    return {
      state: dataStore.state,
      selectedClient: {},
      activeTab: 'invoices',
      viewInvoiceDetails: false,
      addInvoice: false
    }
  },
  components: {
    invoicesList,
    domainsList,
    addInvoice,
    subscriptionList
  },
  created() {
    if (this.state.admin.client.data) {
      this.selectedClient = this.state.admin.client.data
      if (this.selectedClient.stripeid) {
        dataStore.getClientInvoices(this.selectedClient)
      } else {
        this.state.admin.client.invoices = {
          list: [],
          total: 0,
          paid: 0,
          unpaid: 0,
          overdue: 0
        }
      }
      if (this.selectedClient.custid) {
        dataStore.getClientDomains(this.selectedClient, 1)
      } else {
        this.state.admin.client.domains = {
          list: [],
          total: 0,
          page: 1
        }
      }
    }
  },
  methods: {
    updateClient() {
      dataStore.updateClient(this.selectedClient).then((result) => {
        if (result === 'success') {
          // this.selectedClient.password = null
          this.$router.replace('/clients')
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ClientDetails.vue